<template>
  <div>Attributes</div>
</template>

<script>
export default {

}
</script>